import type { ReactNode } from 'react';
import { formatNumber, type NumberValueInput } from './formatNumber';

export interface NumberValueProps {
  empty?: ReactNode;
  fractionDigits?: number;
  unit?: ReactNode;
  unitSpacing?: 'normal' | 'none';
  value: NumberValueInput;
  locale?: string;
}

export function NumberValue({
  empty = '-',
  unit,
  unitSpacing = 'normal',
  value,
  fractionDigits,
  locale,
}: NumberValueProps) {
  const formattedValue = formatNumber(value, { fractionDigits, locale });

  if (formattedValue === null) {
    return <>{empty}</>;
  }

  return (
    <>
      {formattedValue}
      {unit && (
        <>
          {unitSpacing === 'normal' ? ' ' : ''}
          {unit}
        </>
      )}
    </>
  );
}
